import { useState } from 'react'
import { Link } from 'react-router-dom'

import { Button, Field, Input, Note } from '../components/ui'
import { api } from '../lib/api'
import { AuthLayout } from './AuthLayout'

const PASSWORD_MIN = 12

export function Register() {
  const [email, setEmail] = useState('')
  const [fullName, setFullName] = useState('')
  const [password, setPassword] = useState('')
  const [done, setDone] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      // The response is identical whether or not the address already exists —
      // anything else would let this form enumerate users.
      const result = await api.register(email, password, fullName || null)
      setDone(result.detail)
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Could Not Register')
    } finally {
      setBusy(false)
    }
  }

  if (done) {
    return (
      <AuthLayout title="Check Your Email">
        <Note tone="good">{done}</Note>
        <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
          Registering Does Not Grant Access on Its Own: An Administrator Reviews
          the Account and Chooses Which Dashboards It Can See.
        </p>
        <p className="mt-4 text-sm">
          <Link to="/login" style={{ color: 'var(--brand-ink)' }}>Back to Sign In</Link>
        </p>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout title="Register">
      {error && <Note tone="error">{error}</Note>}
      <form onSubmit={submit} noValidate>
        <Field label="Email">
          <Input type="email" value={email} required autoComplete="username"
                 onChange={(event) => setEmail(event.target.value)} />
        </Field>
        <Field label="Name" hint="Optional.">
          <Input value={fullName} autoComplete="name"
                 onChange={(event) => setFullName(event.target.value)} />
        </Field>
        <Field label="Password" hint={`At least ${PASSWORD_MIN} characters.`}>
          <Input type="password" value={password} required minLength={PASSWORD_MIN}
                 autoComplete="new-password"
                 onChange={(event) => setPassword(event.target.value)} />
        </Field>
        <Button type="submit" variant="primary" disabled={busy} className="w-full">
          {busy ? 'Registering…' : 'Register'}
        </Button>
      </form>
      <p className="mt-4 text-sm">
        <Link to="/login" style={{ color: 'var(--brand-ink)' }}>Back to Sign In</Link>
      </p>
    </AuthLayout>
  )
}
